import { Component, OnInit, ViewChild } from '@angular/core';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, ActivatedRoute, NavigationExtras, NavigationEnd } from '@angular/router';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/internal/operators';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';


@Component({
  selector: 'app-reportsummary',
  templateUrl: './reportsummary.component.html',
  styleUrls: ['./reportsummary.component.css']
})
export class ReportsummaryComponent implements OnInit {
  @ViewChild('filterbar', { static: false }) filterbar;
  isfilter: boolean = false;
  isreportmenu: boolean = false;

  _currenturlpath: string = "";
  _reportformname: string = "";
  _fromdate:any="";
  _todate:any="";


  detailsColl: any = [];
  
 
  formname: string = "SummaryReport";

  
  searchtxt: any = "";

  columnDefs = [
    { headerName: 'Staff Code', field: 'staffcode' },
    { headerName: 'Employee Name', field: 'employeename' },
    { headerName: 'Designation', field: 'designationname' },
    { headerName: 'Document Number', field: 'docnum' },
    
    {
      headerName: 'Issue Date', field: 'issuedt',type:'date'
    },
  
    {
      headerName: 'Expiry Date', field: 'expirydt',type:'date'
    },
  
  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  }; 

  constructor( private appService:AppdataService,private loginService:LoginserviceService,public router: Router,private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService,private toastr: ToastrService,private datePipe: DatePipe,private productFindService: NgbModal,) {
      this.fnServiceChanges();
      this._fromdate.setDate(this._fromdate.getDate() - 15);
  }
  
  //Company Check
  fnServiceChanges() {
    
    this._fromdate = new Date();
    this._todate = new Date();
    this._todate.setDate( this._todate.getDate() -30 );

    

      this.loginService.serviceAuthChange.subscribe((value) => {
           
      });
        
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)).subscribe(() => {
          this.fnGetUrlParameters();
        }
      );
    
  }
  
  //Init
  ngOnInit() {
    try{

      
         
            
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }

  
  //Grid
  fnGridReady(params) {
 
  }


  fnGetUrlParameters(){

    let _url=this.route.snapshot.paramMap.get('reportname');
    if (_url){
     this._reportformname=_url;
    }

    this._currenturlpath=this.router.url;
    let url: string = this.router.url.substring(0, this.router.url.indexOf("?"));

    if(url!=""){
      this._currenturlpath=url;
    }

    this.fnGetReport();
  }
  

  fnGetReport() {
    var data = {
      'reportname': this._reportformname,
      'fromdate': this.fnFormatDatetime(this._fromdate),
      'todate': this.fnFormatDatetime(this._todate),
      'companyid': this.loginService.fnGetCompanyId(),
      'modifiedby':this.loginService.fnGetModUserId(),                                                                          
        
    }


    this.appService.getReportDetails(data).subscribe(
        (res)=>{                  
          if(res.json().status===200){
          
            var result = res.json().result;
            
            this.detailsColl=result[0];      
                        
            this.columnDefs = this.fnGenerateColumns(this.detailsColl);

          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }
  

  fnGenerateColumns(data: any[]) {
    let columnDefinitions = [];

    data.map(object => {

      Object
        .keys(object)
        .map(key => {
        
          let mappedColumn = {
            headerName: key.toUpperCase(),
            field: key
          }
          
          if (key != 'empid') {
            columnDefinitions.push(mappedColumn);
          }
          
        })
    })
    //Remove duplicate columns
    columnDefinitions = columnDefinitions.filter((column, index, self) => index === self.findIndex((colAtIndex) => (        
      colAtIndex.field === column.field      
      ))
    )

   
    return columnDefinitions;
  }


  fnReportMenuClick() {
    this.isreportmenu=!this.isreportmenu
  }
  
  fnReportFilterClick() {
    this.filterbar.fromdate = this._fromdate;
    this.filterbar.todate = this._todate;

    this.isfilter=!this.isfilter
  }
  fnApplyFilter(data) { 

    if (data.actiontype === 'DONE') {
      this._fromdate = data.fromdate;
      this._todate = data.todate;  
    }
    else if (data.actiontype === 'RESET') {
      
      this._fromdate = new Date();
      this._todate = new Date();
      this._todate.setDate( this._todate.getDate() -30 ); 
    }

         
    this.isfilter=!this.isfilter
    this.fnGetReport();
  
  }
  
  private fnExport() {

    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.detailsColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  
  }


  fnSetTable() {
   
  }
  fnCloseForm(){
    try{
      this.router.navigate(['/Reports']);
    }catch(ex){
       this.fnShowErrorMsg(ex);
    }
    }
  
  fnFormatDatetime(dt){
    if(dt){
      if(dt===""){
        return null
      }
      else{
        return this.datePipe.transform(dt,"yyyy-MM-dd")  
      }
      
      }else {
      return null
    }
    
  }
  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//  
    }
    else {
      return '';
    }
  
  }  
  
 
  fnConvertDatetime(dt){
    if(dt){
      if(dt===""){
        return null
      }
      else{
        var dateParts = dt.split("-");
        var sdate =new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]+1); 
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }
      
      }else {
      return null
    }
   
  }

  private  fnShowErrorMsg(ex){
    this.toastr.warning('Internal Error', ex);       
  }






}
